import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ABOUT_PAGE } from '../games/siteAbout';
import { setPageMeta } from '../lib/seo';

/** Who makes the site and how; text lives in games/siteAbout.ts (shared with the page file Google reads). */
export function AboutPage() {
  useEffect(() => {
    setPageMeta(`${ABOUT_PAGE.title} · SuperFunUBG`, ABOUT_PAGE.description, '/about');
  }, []);
  return (
    <main id="main" className="legal">
      <div className="band band--hero legal__hero">
        <div>
          <h1 className="hero__title">{ABOUT_PAGE.title}</h1>
          <p className="legal__date">Free, original browser games by Stuffly LLC</p>
        </div>
      </div>
      <article className="legal__body">
        {ABOUT_PAGE.sections.map((s) => (
          <section key={s.heading}>
            <h2>{s.heading}</h2>
            {s.paragraphs.map((p) => (
              <p key={p}>{p}</p>
            ))}
          </section>
        ))}
      </article>
      <nav className="legal__nav" aria-label="More">
        <Link to="/parents">Parents &amp; Teachers</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/">All games</Link>
      </nav>
    </main>
  );
}
